import React from "react";

const TrashIcon = ({ size = 19, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 19 20"
    fill="none"
    {...props}
  >
    <path
      d="M16.4024 4.98307C13.8015 4.70807 11.1851 4.56641 8.57641 4.56641C7.02996 4.56641 5.48351 4.64974 3.93706 4.81641L2.34375 4.98307"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.63867 4.14102L6.8105 3.04935C6.93547 2.25768 7.02919 1.66602 8.34914 1.66602H10.3955C11.7154 1.66602 11.8169 2.29102 11.9341 3.05768L12.1059 4.14102"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.7236 7.61719L14.2159 16.0089C14.13 17.3172 14.0597 18.3339 11.8807 18.3339H6.86641C4.68732 18.3339 4.61702 17.3172 4.53111 16.0089L4.02344 7.61719"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.06836 13.75H10.6692"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.41992 10.416H11.3251"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default TrashIcon;
